module.exports = __webpack_public_path__ + "media/images/_m365_sky-ff96bf27d25819315e335f8a703d0f7f.jpg";